import react, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import HttpClient from '../../../../services/HttpClient'
import Button from '../../../../components/Button/Button'

export default function () {
  const navigate = useNavigate()
  const [errors, setErrors] = useState([])
  const [name, setName] = useState('')
  const [shortName, setShortName] = useState('')
  const [formula, setFormula] = useState(0)

  const onSubmit = async (event) => {
    event.preventDefault()
    setErrors([])

    if (!name) return setErrors(['Name is required'])
    if (!shortName) return setErrors(['Short name is required'])

    const data = {
      name,
      shortName,
      formula,
    }

    const response = await HttpClient().post('/api/v1/dashboard/characters/create/stat', data)
    navigate(`/dashboard`)
  }

  return (
    <div className="page">
      <div className="page__title">New stat</div>
      <form className="form" onSubmit={onSubmit}>
        <div className="form__group flex--row">
          <div className="group__element  width--100">
            <label className="form__label">Name</label>
            <input className="form__input" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="group__element width--20">
            <label className="form__label">Short name</label>
            <input className="form__input" value={shortName} onChange={(e) => setShortName(e.target.value)} />
          </div>
        </div>
        <div className="form__group flex--col">
          <div className="group__element">
            <label className="form__label">Formula</label>
            <input className="form__input" value={formula} onChange={(e) => setFormula(e.target.value)} />
          </div>
        </div>
        <Button type="submit">Create</Button>
      </form>
    </div>
  )
}
